import React from 'react';

import './style.css';
import '../../../grid.css';


const TaxLegal = () => (
    <div className="row">
        <h1 className="section">Tax</h1>
        <p>Because individual tax situations vary, speak with your tax advisor for more information. If this is a commercial project, we assume utility savings do not result in loss of an expense write off against income. THIS SIMULATION IS SUBJECT TO CHANGE.


        </p>
    </div>
);

export default TaxLegal;



// WEBPACK FOOTER //
// ./src/containers/Legal/TaxLegal/index.js